module.exports = __webpack_public_path__ + "static/media/090-comoros.4edbc8d6.svg";